
import APIBackendNew from '../Axios/apiBackendNew';
import ApiConfig from './ApiConfig';

// get list of active corporate scenario
export const activeCorporateList = async () => {
  const token = localStorage.getItem("access_token");
  return await APIBackendNew.get(`${ApiConfig?.newCorporate?.activeList}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};



// get console corporate
export const activeCorporateConsole = async (id) => {
  const token = localStorage.getItem("access_token");
  return await APIBackendNew.get(`${ApiConfig?.newCorporate?.activeCorporateConsole}/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};


// All corporate List API
export const allCorporateList = async () => {
  const token = localStorage.getItem("access_token");
  return await APIBackendNew.get(`${ApiConfig?.newCorporate?.allCorporateList}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};


// corporate detail API
export const getCorporateDetail = async (id) => {
  const token = localStorage.getItem("access_token");
  return await APIBackendNew.get(`${ApiConfig?.newCorporate?.corporateDetail}/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

// flag submit corporate API
export const submitFlagCorporate = async (id, flag_id, data) => {
  const token = localStorage.getItem("access_token");

  return await APIBackendNew.post(
    ApiConfig?.newCorporate?.submitFlagCorporate(id, flag_id),
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};


// submitFeedback
export const submitFeedbackCorporate = async (id, participant_id, data) => {
  const token = localStorage.getItem("access_token");

  return await APIBackendNew.post(
    ApiConfig?.newCorporate?.submitFeedbackCorporate(id, participant_id),
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

// submit Inject corporate
export const submitInjectCorporate = async (id, inject_id, data) => {
  const token = localStorage.getItem("access_token");
  return await APIBackendNew.post(
    ApiConfig?.newCorporate?.submitInjectCorporate(id, inject_id), data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};


// hint flag corporate API
export const hintFlagCorporate = async (id, flag_id) => {
  const token = localStorage.getItem("access_token");

  return await APIBackendNew.get(
    ApiConfig?.newCorporate?.hintFlagCorporate(id, flag_id),
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};



// start APi
export const startActiveScenario = async (id) => {
  const token = localStorage.getItem("access_token");

  return await APIBackendNew.post(
    ApiConfig?.newCorporate?.startActiveScenario(id), {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

// end API
export const endActiveScenario = async (id) => {
  const token = localStorage.getItem("access_token");

  return await APIBackendNew.post(
    ApiConfig?.newCorporate?.endActiveScenario(id), {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}






